function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "gameboy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M0,7.79372714 C0,3.4893705 3.49340363,0 7.79576103,0 L138.646344,0 C142.951824,0 149.030035,2.34373338 152.219551,5.23228851 L176.042105,26.8069571 L147.766626,191.116723 C147.035113,195.367568 143.015276,199.51503 138.806484,200.376569 L35.9867845,221.423729 L6.60053093,202.960613 C2.95515836,200.670258 0,195.320708 0,191.019832 L0,7.79372714 Z",
  id: "path-1"
}), React.createElement("rect", {
  id: "path-3",
  x: 0,
  y: 0.0440677966,
  width: 120.736842,
  height: 76.4067797,
  rx: 7.01999974
}), React.createElement("filter", {
  x: "-0.8%",
  y: "-1.3%",
  width: "101.7%",
  height: "102.6%",
  filterUnits: "objectBoundingBox",
  id: "filter-4"
}, React.createElement("feOffset", {
  dx: -2,
  dy: -2,
  in: "SourceAlpha",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0",
  type: "matrix",
  in: "shadowInnerInner1"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-1194.000000, -372.000000)"
}, React.createElement("g", {
  id: "gameboy",
  transform: "translate(1194.000000, 372.000000)"
}, React.createElement("ellipse", {
  id: "shadow",
  fill: "#F0ECEC",
  cx: 94.6421053,
  cy: 265.864407,
  rx: 77.5052632,
  ry: 10.1355932
}), React.createElement("path", {
  d: "M158.126316,153.584656 C158.126316,150.575222 160.57367,148.135593 163.578947,148.135593 L163.578947,148.135593 C166.590353,148.135593 169.031579,150.572724 169.031579,153.584656 L169.031579,228.751837 C169.031579,231.761272 166.584225,234.2009 163.578947,234.2009 L163.578947,234.2009 C160.567542,234.2009 158.126316,231.763769 158.126316,228.751837 L158.126316,153.584656 Z",
  id: "arm",
  fill: "#427B74"
}), React.createElement("g", {
  id: "leg",
  transform: "translate(58.421053, 188.677966)"
}, React.createElement("rect", {
  id: "Rectangle-12",
  fill: "#427B74",
  x: 0,
  y: 0,
  width: 10.9052632,
  height: 81.0847458,
  rx: 5.45263158
}), React.createElement("polygon", {
  id: "Rectangle-12",
  fill: "#2D5953",
  points: "0 0 10.9052632 0 10.9052632 38.9830508 0 38.9830508"
}), React.createElement("rect", {
  id: "Rectangle-12",
  fill: "#427B74",
  transform: "translate(10.905263, 75.627119) rotate(90.000000) translate(-10.905263, -75.627119) ",
  x: 5.45263158,
  y: 66.2711864,
  width: 10.9052632,
  height: 18.7118644,
  rx: 5.45263158
})), React.createElement("g", {
  id: "leg",
  transform: "translate(120.736842, 188.677966)"
}, React.createElement("rect", {
  id: "Rectangle-12",
  fill: "#427B74",
  x: 0,
  y: 0,
  width: 10.9052632,
  height: 81.0847458,
  rx: 5.45263158
}), React.createElement("polygon", {
  id: "Rectangle-12",
  fill: "#2D5953",
  points: "0 0 10.9052632 0 10.9052632 38.9830508 0 38.9830508"
}), React.createElement("rect", {
  id: "Rectangle-12",
  fill: "#427B74",
  transform: "translate(10.905263, 75.627119) rotate(90.000000) translate(-10.905263, -75.627119) ",
  x: 5.45263158,
  y: 66.2711864,
  width: 10.9052632,
  height: 18.7118644,
  rx: 5.45263158
})), React.createElement("g", {
  id: "body",
  transform: "translate(-0.000000, -0.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Mask",
  fill: "#7EE9CF",
  xlinkHref: "#path-1"
}), React.createElement("polygon", {
  id: "Rectangle-10",
  fill: "#42A089",
  mask: "url(#mask-2)",
  points: "0 0.779661017 38.1684211 29.6271186 38.9473684 223.762712 0 223.762712"
})), React.createElement("rect", {
  id: "front-panel",
  fill: "#56BEA5",
  x: 31.1578947,
  y: 23.3898305,
  width: 146.442105,
  height: 198.813559,
  rx: 7.79999971
}), React.createElement("g", {
  id: "side-panel",
  transform: "translate(3.115789, 37.423729)"
}, React.createElement("path", {
  d: "M22.1685656,60.2340314 C22.1685656,62.5045356 21.68033,63.8891824 20.7038443,64.3880133 C19.7273585,64.8868442 18.5183943,64.6072373 17.0769153,63.5491843 C15.867933,62.661785 14.8310137,61.4669353 13.9661263,59.9645995 C13.3895347,58.9630424 12.9338482,57.7824947 12.5990531,56.4229211 C12.2456582,57.8556956 11.6388512,58.6553063 10.7786137,58.821777 C9.91837629,58.9882477 8.83728328,58.5936585 7.53530228,57.6379977 C6.47511775,56.8598168 5.52189596,55.8763382 4.67560831,54.6875327 C3.82932066,53.4987271 3.15974048,52.2307938 2.66684767,50.8836948 C2.35995215,50.0479661 2.13675875,48.9631013 1.99726079,47.6290676 C1.8112635,45.853926 1.71826625,44.6986245 1.71826625,44.1631282 L1.71826625,31.6004485 L22.1685656,46.6110744 L22.1685656,60.2340314 Z M14.1474727,51.2299349 C14.1474727,52.365187 14.3171927,53.2796075 14.6566378,53.9732238 C14.9960828,54.6668401 15.4866433,55.2491417 16.1283339,55.7201459 C16.7235252,56.1570195 17.1885115,56.2760942 17.5233066,56.0773736 C17.8581017,55.878653 18.0254967,55.2277414 18.0254967,54.1246191 L18.0254967,50.9116575 L14.1474727,48.0651677 L14.1474727,51.2299349 Z M6.11243016,45.8783754 C6.11243016,47.1314366 6.30539945,48.1566327 6.69134382,48.9539943 C7.07728818,49.7513559 7.59574784,50.3889423 8.24673834,50.8667727 C8.85122952,51.3104724 9.33714014,51.4127764 9.70448478,51.1736878 C10.0718294,50.9345992 10.255499,50.1778257 10.255499,48.9033446 L10.255499,45.2084388 L6.11243016,42.1674048 L6.11243016,45.8783754 Z M22.1685656,84.9706222 L9.72540937,79.5321868 L22.1685656,92.344369 L22.1685656,101.886865 L1.71826625,86.876239 L1.71826625,80.9322601 L17.3140607,92.3796542 L1.71826625,76.3216602 L1.71826625,70.9399496 L17.3140607,77.7928087 L1.71826625,66.3454146 L1.71826625,60.3853709 L22.1685656,75.3959968 L22.1685656,84.9706222 Z M19.7273634,110.325079 C21.5873363,113.832294 22.5173087,117.497568 22.5173087,121.321011 C22.5173087,125.240844 21.6036108,127.590339 19.7761874,128.369566 C17.9487641,129.148793 15.3890149,128.33019 12.0968629,125.913734 C9.70679778,124.159413 7.74688078,122.257627 6.21705311,120.208317 C4.68722543,118.159007 3.49686066,115.946552 2.64592308,113.570887 C1.7949855,111.195222 1.36952309,108.700815 1.36952309,106.087594 C1.36952309,103.431532 1.73686222,101.502982 2.47155149,100.301885 C3.20624077,99.1007874 4.36870637,98.5430317 5.95898317,98.6286006 C7.54925996,98.7141696 9.53940106,99.6341004 11.9294662,101.388421 C15.2681175,103.839008 17.8673905,106.817864 19.7273634,110.325079 Z",
  id: "BMO",
  fill: "#1B4B40"
}), React.createElement("path", {
  d: "M21.2412955,24.3618342 C22.2009741,25.0662433 22.9789474,24.744816 22.9789474,23.6439064 C22.9789474,22.5429967 22.2009741,21.0794967 21.2412955,20.3750877 C20.2816169,19.6706786 19.5036437,19.9921058 19.5036437,21.0930155 C19.5036437,22.1939251 20.2816169,23.6574251 21.2412955,24.3618342 Z",
  id: "Oval",
  fill: "#1D4B40"
}), React.createElement("path", {
  d: "M11.9738192,17.5594584 C12.9334978,18.2638675 13.711471,17.9424403 13.711471,16.8415306 C13.711471,15.7406209 12.9334978,14.277121 11.9738192,13.5727119 C11.0141406,12.8683028 10.2361673,13.18973 10.2361673,14.2906397 C10.2361673,15.3915493 11.0141406,16.8550493 11.9738192,17.5594584 Z",
  id: "Oval",
  fill: "#1D4B40"
}), React.createElement("path", {
  d: "M2.12712551,10.3319341 C3.08680411,11.0363432 3.86477733,10.714916 3.86477733,9.61400633 C3.86477733,8.51309668 3.08680411,7.04959669 2.12712551,6.34518761 C1.1674469,5.64077853 0.389473684,5.96220576 0.389473684,7.06311542 C0.389473684,8.16402507 1.1674469,9.62752506 2.12712551,10.3319341 Z",
  id: "Oval",
  fill: "#1D4B40"
}), React.createElement("path", {
  d: "M14.7380213,28.0864259 C15.2178606,29.2704979 16.3790359,30.3509366 17.3315789,30.4996533 C18.284122,30.64837 18.6673241,29.8090487 18.1874848,28.6249767 C17.7076455,27.4409047 16.5464702,26.3604659 15.5939271,26.2117492 C14.6413841,26.0630325 14.258182,26.9023538 14.7380213,28.0864259 Z",
  id: "Oval",
  fill: "#1D4B40"
}), React.createElement("path", {
  d: "M5.18093628,2.0820451 C5.66077558,3.26611712 6.82195089,4.34655586 7.77449393,4.49527256 C8.72703696,4.64398927 9.11023905,3.80466795 8.63039975,2.62059593 C8.15056045,1.43652391 6.98938514,0.356085172 6.03684211,0.207368465 C5.08429907,0.0586517583 4.70109698,0.897973076 5.18093628,2.0820451 Z",
  id: "Oval",
  fill: "#1D4B40"
}), React.createElement("path", {
  d: "M18.1874848,11.6289192 C17.7076455,12.1085822 16.5464702,11.4844035 15.5939271,10.2347771 C14.6413841,8.98515077 14.258182,7.5832848 14.7380213,7.10362185 C15.2178606,6.62395891 16.3790359,7.24813758 17.3315789,8.49776395 C18.284122,9.74739031 18.6673241,11.1492563 18.1874848,11.6289192 Z",
  id: "Oval",
  fill: "#1D4B40"
}), React.createElement("path", {
  d: "M8.63039975,23.6033999 C8.15056045,24.0830629 6.98938514,23.4588842 6.03684211,22.2092578 C5.08429907,20.9596315 4.70109698,19.5577655 5.18093628,19.0781026 C5.66077558,18.5984396 6.82195089,19.2226183 7.77449393,20.4722447 C8.72703696,21.721871 9.11023905,23.123737 8.63039975,23.6033999 Z",
  id: "Oval",
  fill: "#1D4B40"
})), React.createElement("path", {
  d: "M8.56842105,153.584656 C8.56842105,150.575222 11.015775,148.135593 14.0210526,148.135593 L14.0210526,148.135593 C17.0324579,148.135593 19.4736842,150.572724 19.4736842,153.584656 L19.4736842,228.751837 C19.4736842,231.761272 17.0263303,234.2009 14.0210526,234.2009 L14.0210526,234.2009 C11.0096474,234.2009 8.56842105,231.763769 8.56842105,228.751837 L8.56842105,153.584656 Z",
  id: "arm",
  fill: "#427B74"
}), React.createElement("g", {
  id: "controls",
  transform: "translate(47.515789, 152.033898)"
}, React.createElement("g", {
  id: "Group-2",
  fill: "#B09742"
}, React.createElement("polygon", {
  id: "Rectangle-13",
  points: "10.1263158 0 26.4842105 0 29.6 3.81755775 14.3093632 38.7126378 10.1263158 35.8644068"
}), React.createElement("polygon", {
  id: "Rectangle-13",
  transform: "translate(19.882078, 19.578165) rotate(90.000000) translate(-19.882078, -19.578165) ",
  points: "10.0586755 3.22422026 13.6380962 0.0677022528 29.7054796 35.3647557 26.4165702 39.088627 10.0586755 39.088627"
})), React.createElement("g", {
  id: "Group-2",
  transform: "translate(3.115789, 3.118644)",
  fill: "#FFDB60"
}, React.createElement("rect", {
  id: "Rectangle-13",
  x: 10.1263158,
  y: 0,
  width: 16.3578947,
  height: 35.8644068
}), React.createElement("rect", {
  id: "Rectangle-13",
  transform: "translate(18.305263, 17.932203) rotate(90.000000) translate(-18.305263, -17.932203) ",
  x: 10.1263158,
  y: 0,
  width: 16.3578947,
  height: 35.8644068
}))), React.createElement("g", {
  id: "buttons",
  transform: "translate(112.947368, 150.474576)"
}, React.createElement("g", {
  id: "Group-4"
}, React.createElement("polygon", {
  id: "Triangle-2",
  fill: "#3CA0BC",
  points: "11.1512465 0 14.4824756 3.13000867 3.71387157 20.1984181 0 17.4124294"
}), React.createElement("polygon", {
  id: "Triangle-2",
  fill: "#43D5FF",
  points: "13.9390582 2.7859887 25.0903047 20.1984181 2.78781163 20.1984181"
})), React.createElement("g", {
  id: "Group-5",
  transform: "translate(32.756787, 8.357966)"
}, React.createElement("path", {
  d: "M9.40886427,18.8054237 C14.917273,18.8054237 18.8177285,13.5145243 18.8177285,8.70621469 C18.8177285,3.89790509 13.5233671,0 8.71191136,0 C3.90045557,0 0,3.89790509 0,8.70621469 C0,13.5145243 3.90045557,18.8054237 9.40886427,18.8054237 Z",
  id: "Oval-5",
  fill: "#48A65A"
}), React.createElement("ellipse", {
  id: "Oval-5",
  fill: "#5CF47A",
  cx: 11.499723,
  cy: 10.7957062,
  rx: 8.71191136,
  ry: 8.70621469
})), React.createElement("g", {
  id: "Group-5",
  transform: "translate(8.363435, 25.770395)"
}, React.createElement("path", {
  d: "M13.6746967,25.5216465 C21.9694547,25.5216465 25.9554876,17.6446429 25.9554876,11.1190799 C25.9554876,4.59351687 18.6529202,0 12.0164295,0 C5.37993872,0 0,5.29001405 0,11.8155771 C0,18.3411401 5.37993872,25.5216465 13.6746967,25.5216465 Z",
  id: "Oval-5",
  fill: "#C34C4C"
}), React.createElement("ellipse", {
  id: "Oval-5",
  fill: "#FF6363",
  cx: 15.8616869,
  cy: 14.6513156,
  rx: 12.0164295,
  ry: 11.8155771
}))), React.createElement("g", {
  id: "bottom-inputs",
  transform: "translate(52.189474, 203.491525)",
  fill: "#194B40"
}, React.createElement("rect", {
  id: "Rectangle-14",
  x: 0,
  y: 0,
  width: 12.4631579,
  height: 3.89830508,
  rx: 1.94915254
}), React.createElement("rect", {
  id: "Rectangle-14",
  x: 31.1578947,
  y: 0,
  width: 12.4631579,
  height: 3.89830508,
  rx: 1.94915254
})), React.createElement("g", {
  id: "top-inputs",
  transform: "translate(50.400000, 123.000000)"
}, React.createElement("rect", {
  id: "Rectangle-14",
  fill: "#194B40",
  x: 0.231578947,
  y: 0.186440678,
  width: 59.9789474,
  height: 10.1355932,
  rx: 2.33999991
}), React.createElement("ellipse", {
  id: "Oval-2",
  fill: "#0F3029",
  cx: 97.9894737,
  cy: 5.25423729,
  rx: 5.06315789,
  ry: 5.06779661
})), React.createElement("g", {
  id: "face",
  transform: "translate(44.400000, 36.600000)"
}, React.createElement("g", {
  id: "Rectangle-11"
}, React.createElement("use", {
  fill: "#DDFFEF",
  fillRule: "evenodd",
  xlinkHref: "#path-3"
}), React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-4)",
  xlinkHref: "#path-3"
})), React.createElement("ellipse", {
  id: "Oval-6",
  fill: "#08231F",
  cx: 30.3789474,
  cy: 33.5694915,
  rx: 4.67368421,
  ry: 4.6779661
}), React.createElement("path", {
  d: "M55.3052632,41.3661017 C55.3052632,46.1026455 59.1414759,49.9423729 63.8736842,49.9423729 L63.8736842,49.9423729 C68.6058925,49.9423729 72.4421053,46.1026455 72.4421053,41.3661017",
  id: "Oval-6",
  fill: "#08231F"
}), React.createElement("ellipse", {
  id: "Oval-6",
  fill: "#08231F",
  cx: 92.6947368,
  cy: 33.5694915,
  rx: 4.67368421,
  ry: 4.6779661
})))));

var SvgGameboy = function SvgGameboy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "178px",
    height: "276px",
    viewBox: "0 0 178 276",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGameboy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gameboy.45a0ac34.svg";
export { ForwardRef as ReactComponent };